<template>
    <el-tabs type="border-card" :stretch="true">
        <el-tab-pane label="Base Info">
            <el-form label-width="150px" class="detail">
                <el-form-item label="Channel Id" >
                    <div>{{result.channel_id}}</div>
                </el-form-item>
                <el-form-item label="Channel Name"  >
                    <div>{{result.channel_name}}</div>
                </el-form-item>
                <el-form-item label="Sign In"  >
                    <div>
                        <el-button slot="save" size="medium" type="primary" @click="signIn(result.channel_id)">Sign In</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="Copy Info" >
                    <div>
                        <el-button slot="save" size="medium" type="primary" @click="copyInfo()">Copy</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="Channel Type"  >
                    <div>{{result.channel_type}}</div>
                </el-form-item>
                <el-form-item label="Account Level"  >
                    <div>{{'Level ' +  (result.account_level && result.account_level.toUpperCase())}}</div>
                </el-form-item>
                <el-form-item label="Status"  >
                    <div :class="'status-'+result.status">{{result.status && result.status.toUpperCase()}}</div>
                </el-form-item>
                <el-form-item label="Login Email"  >
                    <div>{{result.email}}</div>
                </el-form-item>
                <el-form-item label="Client Finance Email"  >
                    <div>
                        {{result.client_finance_email && result.client_finance_email.replace(/(;|,|，|；)/g, ';\n')}}
                    </div>
                    <div v-if="result.client_finance_email">
                        <el-button slot="save" size="medium" type="primary" @click="copyEmail(result.client_finance_email)">Copy</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="Deduction Rate(%)"  >
                    <div>{{result.defraud*100+"%"}}</div>
                </el-form-item>
                <el-form-item label="Payout Rate(%)"  >
                    <div>{{result.price_percent*100+"%"}}</div>
                </el-form-item>
                <el-form-item label="Insertion Order(IO)"  >
                    <div :class="result.io_file?'status-active':'status-paused'">{{result.io_file==null?"Unsigned":"Signed"}}</div>
                </el-form-item>
                <el-form-item label="Remark"  >
                    <div class="show-new-line">{{result.remark}}</div>
                </el-form-item>
                <el-form-item label="Creator" >
                    <div>{{result.creator}}</div>
                </el-form-item>
                <el-form-item label="Create Time" >
                    <div>{{result.createdAt}}</div>
                </el-form-item>
                <el-form-item label="Update Time" >
                    <div>{{result.updatedAt}}</div>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="URL Info">
            <el-form label-width="150px" class="detail">
                <el-form-item label="API Token"  >
                    <div>{{result.api_token}}</div>
                </el-form-item>
                <el-form-item label="API Url"  >
                    <a :href="result.api_url" class="api-url" target="_blank">{{result.api_url}}</a>
                </el-form-item>
                <el-form-item label="CSV From API"  >
                    <div>
                    <el-button slot="save" size="medium" type="primary" @click="submit">GET CSV</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="PostBack"  >
                    <div v-for="url in postback" :key="url">
                        <a :href="url" target="_blank">{{url}}</a>
                    </div>
                </el-form-item>
                <el-form-item label="Event Pb"  >
                    <div>{{ result.event_pb }}</div>
                </el-form-item>
            </el-form>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
export default {
	data() {
		return {
            result: {},
            postback:[],
		};
	},
	methods:{
		async loaddata(v){
            this.postback = [],
            this.result = await this.$post('/channel/detail',{channel_id:v});
            if(this.result.postback != null) {
                this.postback = JSON.parse(this.result.postback).all;
            }
		},
		async submit() {
            const link = this.result.api_url;
            const time = this.$utils.date_format((new Date()),'YYYY_MM_DD');
            const file_name = this.result.channel_name + '_API_' + time + '.csv';
            await this.$getCsv('/csv/getChannelApiCsv', {link: link, isCsv: true}, file_name);
        },
        async signIn(channel_id) {
			const result = await this.$post('/channel/signIn',{ channel_id });
			window.open(result);
        },
        async copyEmail(email) {
            const text = email && email.replace(/(;|,|，|；)/g, ';');
			await this.$copyText((text));
			this.$message({
				type:'success',
				message:'Copy success',
			})
        },
        async copyInfo() {
            const text = `Pub id : ${this.result.channel_id}
Pub name: ${this.result.channel_name}

Doc
http://www.pikakads.com/apiDocument.html
API Token
${this.result.api_token}
API Url
http://api.pikakads.com/offers/?id=${this.result.channel_id}&token=${this.result.api_token}

Tracking Parameters:
&aff_sub={your click id}
&aff_sub2={your source id}
&gaid={google id}
&idfa={ios bundle id}
&app_name={your application name}
&aff_sub3={your apps’ package id}
&aff_sub6={your creative name}
&aff_sub7={your creative id}
&imp_id={YOUR IMPRESSION ID}


Login url: http://aff.pikakads.com/
login email: ${this.result.email}
Password: ${this.result.channel_name}@pikakads$123!`;
            
			await this.$copyText((text));
			this.$message({
				type:'success',
				message:'Copy success',
			})
        },
	},
	props: ["id"],
	watch: {
		id(v) {
			this.loaddata(v);
		}
	},
	mounted(){
		this.loaddata(this.id);
	}
};
</script>


<style scoped>
.detail-tab{
    background-color: rgb(175, 187, 236);
    height: 30px;
    width: 100%;
    text-align: center;
vertical-align: bottom;
}
.el-form-item {
    /* margin:0 10px 0 10px; */
    width: 100%;
    border-style: solid;
    border-color:rgb(230,230,230);
    border-width: 0px 0px 1px 0px;
}
.api-url {
    word-wrap:break-word;
}
</style>
